import { TypedSupabaseClient } from "@lib/utils/supabase";
import { useSupabase } from "../../app/_components/providers/supabase-provider";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { Database } from "@src/types/db";
import { queryKeys } from "@src/queries";

type PlaylistRow = Database['public']['Tables']['playlists']['Row']
type PlaylistSong = Pick<Database['public']['Tables']['playlists_songs']['Row'], 'deletedAt'>
type PlaylistWithSongs = PlaylistRow & { playlists_songs: PlaylistSong[] | null }

export type PlaylistSummary = PlaylistRow & {
  songCount: number
}

export async function getPlaylistsByUserId(client: TypedSupabaseClient, userId: string): Promise<PlaylistSummary[]> {
  const { data } = await client.from('playlists')
    .select(
      `
      coverKey,
      createdAt,
      deletedAt,
      id,
      name,
      secret,
      status,
      updatedAt,
      userId,
      playlists_songs (
        deletedAt
      )
      `
    )
    .eq('userId', userId)
    .eq('status', 'active')
    .order('updatedAt', { ascending: false })
    .throwOnError();

  return (data as PlaylistWithSongs[]).map(({ playlists_songs, ...playlist }) => ({
    ...playlist,
    songCount: (playlists_songs ?? []).filter(({ deletedAt }) => deletedAt === null).length,
  }));
}

export const getPlaylistsByUserIdOptions = (supabase: TypedSupabaseClient, userId: string) => queryOptions({
  queryKey: queryKeys.playlists.byUserId(userId),
  queryFn: () => getPlaylistsByUserId(supabase, userId)
})

export const useGetPlaylistsByUserId = (userId: string) => {
  const { supabase } = useSupabase();

  return useSuspenseQuery(
    getPlaylistsByUserIdOptions(supabase, userId)
  );
}
